"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultError = exports.defaultErrorText = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_1 = require("./styled");
var material_1 = require("@mui/material");
var error_icon_1 = require("../error-icon");
var hooks_1 = require("../../hooks");
exports.defaultErrorText = {
    message: 'Something went wrong.',
};
var DefaultError = function (_a) {
    var _b = _a.text, text = _b === void 0 ? exports.defaultErrorText : _b;
    var theme = (0, hooks_1.useGracefulTheme)();
    return ((0, jsx_runtime_1.jsxs)(styled_1.DefaultErrorStyled, __assign({ component: material_1.Paper }, { children: [(0, jsx_runtime_1.jsx)(error_icon_1.ErrorIcon, { sx: { width: '100%', height: 250 } }), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({}, {
                sx: {
                    color: theme.secondary,
                    fontWeight: '700',
                },
            }, { children: "".concat(text.message) }))] })));
};
exports.DefaultError = DefaultError;
